<template>
  <j-modal
    title="家长联系方式"
    :width="600"
    :visible="visible"
    :mask="true"
    :fullscreen="izMobile"
    class="j-super-query-modal"
    style="top: 5%; max-height: 95%"
    @cancel="handleCancel"
    :footer="null"
  >
    <div v-for="(item, index) in detailList" :key="index" class="list-item">
      <div>{{ item.realname }}手机：</div>
      <div style="font-weight: bold">{{ item.phone }}</div>
    </div>
  </j-modal>
</template>

<script>
import JDate from '@/components/jeecg/JDate.vue'
import { getAction } from '@api/manage'

export default {
  name: 'PhoneDetailModal',
  components: {
    JDate,
  },
  props: {
    // detailList: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      visible: false,
      detailList: [],
    }
  },
  computed: {
    izMobile() {
      return this.device === 'mobile'
    },
  },
  methods: {
    show(data) {
      this.visible = true
      getAction('/ddUser/HomeSchoolDiscuss', { studentId: data.studentId }).then((res) => {
        if (res.success) {
          console.log('家长手机号码--', res)
          // this.parentPhone = res.result.phone
          this.detailList = res.result
        }
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>

<style lang="less" scoped>
.list-item {
  display: flex;
  // justify-content: space-between;
  align-items: start;
  margin-bottom: 12px;
  font-size: 13px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
</style>
